module.exports = __webpack_public_path__ + "static/media/movies.c18fce3c.png";